import { render, staticRenderFns } from "./companyIntro.vue?vue&type=template&id=1721c85d&scoped=true"
import script from "./companyIntro.vue?vue&type=script&lang=ts"
export * from "./companyIntro.vue?vue&type=script&lang=ts"
import style0 from "./companyIntro.vue?vue&type=style&index=0&id=1721c85d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721c85d",
  null
  
)

export default component.exports